import React from 'react';
import { getContext } from 'common';
import ToggleSwitch from 'components/ToggleSwitch';
import styled from './styles';

export interface StatusBarToggleSwitchProps extends React.ComponentPropsWithRef<'div'> {
  /** Props need to be passed into ToggleSwitch */
  toggleSwitchProps?: {};
}

/**
 * StatusBarToggleSwitch component. This component is the wrapper of ToggleSwitch.
 * Any other props than the `checked`, `disabled` and `onChange` props will be provided to the root element
 */
const StatusBarToggleSwitch = React.forwardRef<HTMLElement, StatusBarToggleSwitchProps>((props: StatusBarToggleSwitchProps, ref) =>
  getContext(({ RTL }: { RTL: boolean }) => {
    const {
      toggleSwitchProps,
      ...otherProps
    } = props;
    return (
      <styled.StatusBarToggleSwitch ref={ref} $rtl={RTL} {...otherProps}>
        <ToggleSwitch stateColor {...toggleSwitchProps} />
      </styled.StatusBarToggleSwitch>
    );
  }));

StatusBarToggleSwitch.displayName = 'StatusBarToggleSwitch';

StatusBarToggleSwitch.defaultProps = {
  toggleSwitchProps: {}
};

export default StatusBarToggleSwitch;
